export default "__VITE_ASSET__cjOkDmyF__"